// extracted by mini-css-extract-plugin
export var avatar = "_pj-3";
export var avatarContainer = "_pj-2";
export var avatarSpacer = "_pj-5";
export var avatarSpacerContainer = "_pj-4";
export var avatarStackContainer = "_pj-1";
export var bubble = "_pj-0";
export var remainderBubble = "_pj-6";